<div class="po-wrapper">
  <po-page-default p-title="Acesso Restrito" class="">
    <div class="po-page-login-body center">
      <div style="display: flex; justify-content: center;">
        <img class="po-mb-3" src="assets/closed.png" />
      </div>
      <div class="po-page-blocked-user-header po-mb-md-3 po-row">
        <div class="po-md-12">Opss!</div>
      </div>
      <div class="po-page-blocked-user-text po-font-text po-row">
        <div class="po-mb-sm-2 po-mb-md-3 po-md-12">
          Tivemos que bloquear essa tela temporariamente.
        </div>
        <div class="po-mb-sm-2 po-mb-md-3 po-md-12">
          Mas não se preocupe! Clique no botão a seguir para retornar para o
          Início.
        </div>
      </div>

      <div class="po-page-blocked-user-mobile-bottom-alignment">
        <div class="po-row">
          <po-button
            class="po-lg-12 po-sm-12 po-page-blocked-user-button"
            p-label="Voltar para o Início"
            p-kind="primary"
            (p-click)="buttonClick()"
          >
          </po-button>
        </div>
      </div>
    </div>
  </po-page-default>
</div>